import { createFileRoute } from "@tanstack/react-router";
import OurWork from "@/pages/OurWork";
import { SITE_URL, OG_IMAGE } from "@/lib/site-data";
import { breadcrumbLd, webPageLd } from "@/lib/seo";

const title = "Our Work — Flooring Project Gallery | JTB Floors";
const description =
  "Browse recent hardwood, tile, and marble flooring installations completed by JTB Floors across the Barrington, IL area.";

export const Route = createFileRoute("/our-work")({
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "website" },
      { property: "og:url", content: `${SITE_URL}/our-work` },
      { property: "og:image", content: OG_IMAGE },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: OG_IMAGE },
    ],
    links: [{ rel: "canonical", href: `${SITE_URL}/our-work` }],
    scripts: [breadcrumbLd("Our Work", "/our-work"), webPageLd("CollectionPage", title, description, "/our-work")],
  }),
  component: OurWork,
});
